'use strict';

import angular from 'angular';

export default class MemTransactionFormCtrl {
  model = {
    name: ''
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, MemTxnSvc,
    MemTypeSvc, GroupSvc, GroupAuthSvc) {
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId;
    var personId = $stateParams.perId;
    this.personId = personId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.MemTxnSvc = MemTxnSvc;
    this.LoaderSvc = LoaderSvc;
    this.model = {amountType: 'debit', amount: 0.00};
    var that = this;

    this.amountTypes = [{label: 'Debit/Owed', value: 'debit'},
      {label: 'Credit/Paid', value: 'credit'}];
    // filter for direct membership groups
    this.filterFromGroup = function(group) {
      // must have array, and array must be nonempty
      return group.membership && group.membership.length > 0;
    };
    var minPath;
    this.filterToGroup = function(group) {
      //set default
      var g = group.group;
      if(g && g.hierarchyLevel && (!minPath || g.hierarchyLevel < minPath)) {
        minPath = g.hierarchyLevel;
        that.model.toGroupId = g.id;
      }
      return true;
    };

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(ctxId, 'memberTransaction', 'C');

      this.submit = this.createMemberTransaction;
      that.headerText = 'New Member Transaction';
      that.submitText = 'Create Member Transaction';
      GroupSvc.getTimePeriods({groupId: ctxId}).$promise.then(function(tp) {
        that.timePeriods = tp;
      });
      this.cancelSref = 'group.memberView.memberTransaction.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(ctxId, 'memberTransaction', 'U');

      this.submit = this.updateMemberTransaction;
      var mtId = $stateParams.mtId;
      that.mtId = mtId;
      that.headerText = 'Edit Member Transaction';
      that.submitText = 'Update Member Transaction';
      this.MemTxnSvc.get({groupId: ctxId, personId, id: mtId}).$promise
        .then(function(mt) {
          mt = mt.toJSON(); // remove angular resource values
          mt.amountType = mt.amount <= 0 ? 'debit' : 'credit';
          mt.amount = Math.abs(mt.amount) / 100; // cents

          that.model = angular.extend({}, that.model, angular.copy(mt));
          that.display = mt;
        });
      this.cancelSref = 'group.memberView.memberTransaction.list';
    }
  }

  prepMemTxn(memTxn) {
    var that = this;
    memTxn.toGroupId = memTxn.toGroupId || that.ctxId;
    memTxn.amount = memTxn.amount * 100; // cents
    if(memTxn.amountType === 'debit') { memTxn.amount = memTxn.amount * -1; }
    delete memTxn.amountType;
    return memTxn;
  }

  createMemberTransaction() {
    var that = this;
    that.LoaderSvc.start();
    var memTxn = that.prepMemTxn(angular.copy(that.model));

    var reqParams = {
      groupId: that.ctxId,
      personId: that.personId
    };
    that.MemTxnSvc.create(reqParams, memTxn).$promise
      .then(function(mt) {
        that.LoaderSvc.stopSuccess('Member Transaction Created');
        that.$state.go('group.memberView.memberTransaction.view',
          {mtId: mt.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateMemberTransaction() {
    var that = this;
    that.LoaderSvc.start();
    var memTxn = that.prepMemTxn(angular.copy(that.model));
    // remove rels that cannot be edited
    delete memTxn.timePeriod;

    var reqParams = {
      groupId: that.ctxId,
      personId: that.personId,
      id: that.mtId
    };
    this.MemTxnSvc.update(reqParams, memTxn).$promise.then(function() {
      that.$state
        .go('group.memberView.memberTransaction.view', {mtId: that.mtId});
      that.LoaderSvc.stopSuccess('Member Transaction Updated');
    })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

MemTransactionFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'MemTxnSvc',
  'MemTypeSvc',
  'GroupSvc',
  'GroupAuthSvc'
];
